import type { Ref } from 'react';
import React, { forwardRef } from 'react';
import dot from 'dot-object';
import type { DataGridCellRendererProps, CommentElementProps } from '@myosh/odin-components';
import { DataGridDataCell, Tooltip, parseDate } from '@myosh/odin-components';
import { formatDisplayDate, formatDisplayTime } from '../../utils/date-util';
import { stripHTML } from '../../utils/dom-utils';

const formatValueAsTSX = (comments: Array<CommentElementProps>): React.JSX.Element => {
  return (
    <>
      {comments.map((comment, index) => {
        const date = parseDate(comment.date);
        const formattedDate = date ? formatDisplayDate(date) : '-';
        const formattedTime = date ? formatDisplayTime(date) : '-';
        const safeMessage = stripHTML(comment.message);
        const tooltipText = `${formattedDate} - ${formattedTime} - ${comment.user}: ${safeMessage}`;

        return (
          <Tooltip key={index} description={tooltipText} tooltipClassName="bg-mono-1" tooltipZIndexCheck={true}>
            <div className="mb-2">
              <strong>
                {formattedDate} - {formattedTime} - {comment.user}:
              </strong>
              <span className="ml-1 inline">{safeMessage}</span>
            </div>
          </Tooltip>
        );
      })}
    </>
  );
};

interface HistoryFieldDataCellProps extends DataGridCellRendererProps {
  allowCellScrollBar?: boolean;
}

const HistoryFieldDataCell = (
  { column, rowData, allowCellScrollBar }: HistoryFieldDataCellProps,
  forwardRef: Ref<HTMLDivElement>
) => {
  const value: Array<CommentElementProps> = (column.valuePath ? dot.pick(column.valuePath, rowData) : []) ?? [];
  const displayValue = formatValueAsTSX(value);
  return (
    <DataGridDataCell
      ref={forwardRef}
      value={displayValue}
      width={column.width}
      allowCellScrollBar={allowCellScrollBar}
      renderAsHTML={true}
    />
  );
};

export default forwardRef(HistoryFieldDataCell);
